import axios from 'axios';
import { API_BASE_URL } from '../../config/env';

const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

export interface ContactInquiryPayload {
  name: string;
  email: string;
  subject: string;
  message: string;
  sourcePage?: string;
  website?: string;
}

export async function submitPublicContactInquiry(payload: ContactInquiryPayload): Promise<string> {
  try {
    const response = await publicApi.post('/user-management/api/public/contact', payload);
    return response.data?.message ?? 'Your message has been sent successfully.';
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const responseData = error.response?.data;

      if (typeof responseData === 'string' && responseData.trim()) {
        throw new Error(responseData.trim());
      }

      if (responseData && typeof responseData === 'object') {
        const data = responseData as Record<string, unknown>;
        const candidate =
          (typeof data.message === 'string' && data.message) ||
          (typeof data.error === 'string' && data.error) ||
          (typeof data.detail === 'string' && data.detail);

        if (candidate) {
          throw new Error(candidate);
        }
      }

      /* axios 0.21 does not set a code for network failures — it only sets the
         message "Network Error" — so matching on the code alone let that raw
         string reach the page. Match both until the axios upgrade lands. */
      if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        throw new Error('We could not reach the ShiftWagon server right now. Please try again.');
      }
    }

    if (error instanceof Error && error.message.trim()) {
      throw error;
    }

    throw new Error('We could not send your message right now. Please try again.');
  }
}
